import React, { useEffect, useReducer } from 'react';
import cn from 'classnames';

// TYPES
import { TWindowOrientation } from '@Managers/Device/UseWindowDimensions.types';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getGlobalStyles } from '@Managers/Redux/AppState/AppState';

// IMAGES
import brandLogo from '@Images/p_games.png';

const BrandLogo: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: { gameTitle: string; time: string }, newState: any) => ({ ...state, ...newState }), {
        gameTitle: '',
        time: ''
    });

    const globalStyles = useAppSelector(getGlobalStyles);
    const brandCN = cn(styles.brand_logo_container, globalStyles.orientation, globalStyles.handMode);

    useEffect(() => {}, []);

    return (
        <div className={brandCN}>
            <img src={brandLogo} alt="" />
        </div>
    );
};

export default BrandLogo;
